import type { NitroFetchRequest, $Fetch } from 'nitropack'
import type { FetchOptions } from 'ofetch'
import type { GetCategoryName } from '~/types/apis/getCategoryName'

export const categoryRepository = <T>(fetch: $Fetch<T, NitroFetchRequest>) => ({
  async getCategoryName(
    key: string,
    language: string,
    options: FetchOptions = {}
  ): Promise<GetCategoryName> {
    return fetch<GetCategoryName>('/v2/storefront/category/' + key, {
      ...options,
      method: 'GET',
      headers: {
        'Accept-Language': language
      }
    })
  }
})
